import React from "react";
import Button from "@mui/material/Button";
import { tallyTokens } from "../../theme.tsx";

interface ComposerActionButtonProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  "aria-label"?: string;
}

/**
 * One action in the composer's row beneath the field.
 *
 * Shared so every action - dictation, voice mode, sources - keeps the same
 * height, icon size and hover treatment. They sit side by side, so any
 * disagreement about sizing reads as broken.
 */
const ComposerActionButton = React.forwardRef<
  HTMLButtonElement,
  ComposerActionButtonProps
>(({ icon, label, onClick, disabled, ...rest }, ref) => (
  <Button
    ref={ref}
    onClick={onClick}
    disabled={disabled}
    disableRipple
    startIcon={icon}
    {...rest}
    sx={{
      minWidth: 0,
      flexShrink: 0,
      textTransform: "none",
      gap: "5px",
      padding: "4.5px 9px",
      borderRadius: "999px",
      fontSize: "12.5px",
      fontWeight: 400,
      lineHeight: 1.4,
      color: tallyTokens.ink2,
      "& .MuiButton-startIcon": { margin: 0 },
      "&:hover": {
        backgroundColor: tallyTokens.surface2,
        color: tallyTokens.ink,
      },
    }}
  >
    {label}
  </Button>
));

ComposerActionButton.displayName = "ComposerActionButton";

export default ComposerActionButton;
